/**
 * Generates and plays a premium, soft double-ding chime using the Web Audio API.
 * Bypasses network requests and asset loading issues entirely.
 */
export const playSuccessChime = () => {
  try {
    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContext) return;
    
    const ctx = new AudioContext();
    
    // First tone: C5 (523.25 Hz), soft start
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.type = 'sine';
    osc1.frequency.setValueAtTime(523.25, ctx.currentTime);
    
    gain1.gain.setValueAtTime(0.0, ctx.currentTime);
    gain1.gain.linearRampToValueAtTime(0.12, ctx.currentTime + 0.02); // fade in
    gain1.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.18); // fade out
    
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    
    osc1.start();
    osc1.stop(ctx.currentTime + 0.18);
    
    // Second tone: E5 (659.25 Hz) starting 0.08s later
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.type = 'sine';
    osc2.frequency.setValueAtTime(659.25, ctx.currentTime + 0.08);
    
    gain2.gain.setValueAtTime(0.0, ctx.currentTime + 0.08);
    gain2.gain.linearRampToValueAtTime(0.12, ctx.currentTime + 0.10); // fade in
    gain2.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.38); // fade out
    
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    
    osc2.start(ctx.currentTime + 0.08);
    osc2.stop(ctx.currentTime + 0.38);
  } catch (e) {
    console.error('Failed to play success chime:', e);
  }
};
